import { useQuery } from '@tanstack/react-query';
import { StatCardGrid } from '@/components/common/StatCardGrid';
import { teacherInactivationSummaryQueryOptions } from '../api/teacherInactivations.api';
import type {
  TeacherInactivationFilterParams,
  TeacherInactivationSummary,
} from '../types/teacherInactivation.types';

const SUMMARY_CARDS: { key: keyof TeacherInactivationSummary; label: string }[] = [
  { key: 'total', label: 'Total' },
  { key: 'pending', label: 'Pending' },
  { key: 'approved', label: 'Approved' },
  { key: 'rejected', label: 'Rejected' },
];

interface TeacherInactivationSummaryCardsProps {
  params: TeacherInactivationFilterParams;
}

export function TeacherInactivationSummaryCards({ params }: TeacherInactivationSummaryCardsProps) {
  const { data, isLoading, isError } = useQuery(teacherInactivationSummaryQueryOptions(params));

  return (
    <StatCardGrid
      stats={SUMMARY_CARDS.map((card) => ({ ...card, value: data?.[card.key] }))}
      isLoading={isLoading}
      isError={isError}
    />
  );
}
